module.exports = __webpack_public_path__ + "img/mercedes-eqc-2.b633dec3.jpg";